const CartCommon = function(s_account){
	const showMessage = (msg) => {
		const notificationDiv = document.getElementById("divNotification");
		notificationDiv.innerHTML = msg;
		notificationDiv.classList.remove("hide");
		notificationDiv.focus();
	};
	
	const jsMessages = JSON.parse(document.getElementById('JsMessages').value);
	
	const hideMessage = () => {
		const notificationDiv = document.getElementById("divNotification");
		notificationDiv.classList.add("hide");
	};
	
	const showBusy = () => {
		const loadingIcon = document.getElementsByClassName("loading")[0];
		loadingIcon.classList.remove("hide");
	};

	const hideBusy = () => {
		const loadingIcon = document.getElementsByClassName("loading")[0];
		loadingIcon.classList.add("hide");
	};
	
	const cartId = document.getElementById("UserCart_CartID") ? document.getElementById("UserCart_CartID").value : "";
	const token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "";

	const checkCartHasCoupon = () => {
		const showCoupons = document.getElementById("divShowCouponCodes");
		const enterCodeBtn = document.getElementById("btnEnterCouponCode");
		if (showCoupons.classList.contains("hide") && enterCodeBtn) enterCodeBtn.classList.remove("hide");
		else if(enterCodeBtn) enterCodeBtn.classList.add("hide");
	};
	
	const updateHeaderCartSummary = (data) => {
		if (data.PartialView1) {
			const headerCartSummary = document.getElementById("userSpecificLinksBox").querySelectorAll(".cartSummaryContainer")[0];
			headerCartSummary.innerHTML = data.PartialView1;
			const headerLinks = new header4i();
			headerLinks.HeaderCart.Init();
		}
	};

	const omniture = (s_account) => {
		const account = typeof s_account === 'string' ? s_account : '4imprintprod';
            	let s = typeof s_gi === 'function' ? s_gi(account) : '';
            	
		const addCouponCode = (couponCode) => {
			if(s !== ""){
				s.linkTrackVars = 'eVar5,events';
				s.linkTrackEvents = 'event2';
				s.eVar5 = couponCode;
				s.events = 'event2';
				s.tl(true, 'o', 'Coupon Codes');
			}
		};
		const removeItem = (product) => {
			if(s !== ""){
				s.linkTrackVars = 'products,events';
				s.linkTrackEvents = 'scRemove';
				s.events = 'scRemove';
				s.products = product;
				s.tl(true, 'o', 'Cart Delete Item');
			}
		};
		const shareCart = () =>{
			if(s !== ""){
				s.linkTrackVars = 'prop21';
				s.linkTrackEvents = 'None';
				s.prop21 = "cart share";
				s.tl(true, 'o', 'Share Cart');
			}
		};
		const newBoardCreation = () => {
			if (s !== "") {
	          		s.linkTrackVars = 'prop26';
	          		s.linkTrackEvents = 'None';
	          		s.prop26 = "Fav Board Creations";
	          		s.tl(true, 'o', 'Fav Board Creations');
	      		}
	    	};
		return {
			AddCouponCode: addCouponCode,
			RemoveItem: removeItem,
			ShareCart: shareCart,
			NewBoardCreation: newBoardCreation
		};
	};

	const gtm = () =>{
		const logCartRemoval = (product, callBack) => {
			if (typeof dataLayer !== 'undefined' && !!window.ga && product) {
				let products = [];
				products.push(getProductObject(product));

				// Measure the removal of a product from a shopping cart.
				dataLayer.push({
					'event': 'removeFromCart',
					'ecommerce': {
						'remove': {
							'products': products
						}
					},
					'eventCallback': function() {
						if (callBack) callBack();
					}
				});
			} else {
				if (callBack) callBack();
			}
		};

		const getProductObject = (product) => {
			return {
				'name': product.getAttribute('data-description').replace("'", ''),
				'id': product.getAttribute("data-catalog"),
				'price': product.getAttribute("data-unit-price"),
				'brand': product.getAttribute('data-brand'),
				'category': product.getAttribute('data-category'),
				'variant': product.getAttribute('data-color'),
				'quantity': product.getAttribute("data-quantity")

			};
		};

		return {
			LogCartRemoval: logCartRemoval
		};
	};
	
	return{
		ShowMessage: showMessage,
		HideMessage: hideMessage,
		ShowBusy: showBusy,
		HideBusy: hideBusy, 
		Token: token,
		CartID: cartId, 
		Omniture: omniture, 
		GTM: gtm,
		Messages: jsMessages, 
		CheckCartHasCoupon: checkCartHasCoupon, 
		UpdateHeaderCartSummary: updateHeaderCartSummary
	};
};